<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h1>Hotel Penjara Karosta</h1>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-1.jpg')"
            fluid
            class="content-picture"
            style="max-width: 80%;"
          />
          <br>
          <i style="font-size: 14px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Sebuah tempat menginap pada umumnya tentu menawarkan rasa nyaman dengan berbagai fasilitas yang dapat dinikmati. Namun, di Eropa, tepatnya Latvia, terdapat hotel yang tidak seperti hotel pada biasanya lho. 😱
          </p>
          <p class="mt-3 text-justify">
            &emsp;Hotel Prison Karosta atau Hotel Penjara Karosta, dulunya adalah sebuah penjara aktif yang digunakan pada masa Perang Dunia II. Pada tahun 1997 penjara ini kemudian dialihfungsikan sebagai destinasi wisata. Disini, kamu menandatangani persetujuan untuk diperlakukan selayaknya tahanan pada suatu penjara lho! 🗝
          </p>
        </b-col>

        <b-col cols="5" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-2.jpeg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 14px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
        </b-col>

        <b-col cols="5" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-3.jpg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 14px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-4.jpg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 14px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Mulai dari dinding dan ranjang besi yang nggak diubah sama sekali. Nggak cuma itu, makanan yang disajikan juga sama seperti yang dimakan para tahanan dan disuguhkan melalui lubang pintu saja. Serta kalau kamu melanggar peraturan atau “beruntung”, maka kamu juga bakal dapet hukuman dari penjaga tahanan. Unik banget ya! 😆
          </p>
          <p class="mt-3 text-justify">
            &emsp;Bagi kamu yang mau berkunjung ke Hotel Penjara Karosta dan ingin merencanakan jadwal travellingmu sendiri, bareng sama STARGUIDES aja! STARGUIDES siap menemani tiap perjalananmu! 💫
          </p>
          <p class="mt-3 text-justify" style="font-size: 14px;">
            <i>
              Source: <a href="http://karostascietums.lv/en/">http://karostascietums.lv/en/</a>
            </i>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12">
          <h4>Hotel Penjara Karosta</h4>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-1.jpg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 11px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
        </b-col>

        <b-col cols="12" class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Sebuah tempat menginap pada umumnya tentu menawarkan rasa nyaman dengan berbagai fasilitas yang dapat dinikmati. Namun, di Eropa, tepatnya Latvia, terdapat hotel yang tidak seperti hotel pada biasanya lho. 😱
          </p>
          <p class="mt-3 text-justify">
            &emsp;Hotel Prison Karosta atau Hotel Penjara Karosta, dulunya adalah sebuah penjara aktif yang digunakan pada masa Perang Dunia II. Pada tahun 1997 penjara ini kemudian dialihfungsikan sebagai destinasi wisata. Disini, kamu menandatangani persetujuan untuk diperlakukan selayaknya tahanan pada suatu penjara lho! 🗝
          </p>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-2.jpeg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 11px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-3.jpg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 11px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
          <b-img
            :src="require('@/assets/img/articles/1911262/hotel-karosta-4.jpg')"
            fluid
            class="content-picture"
          />
          <br>
          <i style="font-size: 11px; color: #7f7f7f;">http://karostascietums.lv/en/</i>
        </b-col>

        <b-col cols="12" class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Mulai dari dinding dan ranjang besi yang nggak diubah sama sekali. Nggak cuma itu, makanan yang disajikan juga sama seperti yang dimakan para tahanan dan disuguhkan melalui lubang pintu saja. Serta kalau kamu melanggar peraturan atau “beruntung”, maka kamu juga bakal dapet hukuman dari penjaga tahanan. Unik banget ya! 😆
          </p>
          <p class="mt-3 text-justify">
            &emsp;Bagi kamu yang mau berkunjung ke Hotel Penjara Karosta dan ingin merencanakan jadwal travellingmu sendiri, bareng sama STARGUIDES aja! STARGUIDES siap menemani tiap perjalananmu! 💫
          </p>
          <p class="mt-3 text-justify" style="font-size: 14px;">
            <i>
              Source: <a href="http://karostascietums.lv/en/">http://karostascietums.lv/en/</a>
            </i>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article191126-hotel-penjara-karosta',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article191126-hotel-penjara-karosta.vue